import * as React from "react";
import type { SVGProps } from "react";
const SvgRateIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="rate_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M153.6 512c0 198.101 160.299 358.4 358.4 358.4 198.101 0 358.4-160.299 358.4-358.4 0-198.101-160.299-358.4-358.4-358.4A358.187 358.187 0 0 0 153.6 512zm806.4 0c0 247.595-200.405 448-448 448S64 759.595 64 512 264.405 64 512 64s448 200.405 448 448zM591.36 663.68a29.653 29.653 0 1 1 59.307 0 29.653 29.653 0 0 1-59.307 0zm29.61-93.653a93.653 93.653 0 1 0 0 187.306 93.653 93.653 0 0 0 0-187.306zm-217.983-239.36a29.653 29.653 0 1 0 0 59.306 29.653 29.653 0 0 0 0-59.306zm-93.654 29.653a93.653 93.653 0 1 1 187.307 0 93.653 93.653 0 0 1-187.307 0zm.768 282.325c-19.669 19.67-22.144 49.152-5.504 65.835 16.683 16.64 46.166 14.208 65.878-5.504l340.949-340.992c19.712-19.67 22.187-49.152 5.547-65.835-16.683-16.64-46.166-14.208-65.878 5.547L310.101 642.603z"
    />
  </svg>
);
export default SvgRateIcon;
